import React, { useState } from "react";
import { Button, DialogActions, DialogContent, Typography } from "@mui/material";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import PolicyPickList from "./PolicyPickList";
import { ViewPowerOfAttorneyAction, newActionId } from "./quickActions";

interface Props {
  policies: MimshakData[];
  onComplete: (action: ViewPowerOfAttorneyAction) => void;
  onCancel: () => void;
  policiesFooter?: React.ReactNode;
}

/** ייפוי כוח לצפייה – בוחרים קופה / תיק השקעות; הטופס של היצרן מוכן אחר כך (בשלב הטפסים של הסל) */
const ViewPowerOfAttorneyForm: React.FC<Props> = ({ policies, onComplete, onCancel, policiesFooter }) => {
  const [marked, setMarked] = useState<MimshakData | null>(null);

  return (
    <>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          לאיזו קופה / תיק השקעות?
        </Typography>
        <PolicyPickList policies={policies} selected={marked} onPick={setMarked} footer={policiesFooter} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" size="large">
          חזור
        </Button>
        <Button
          onClick={() => marked && onComplete({ kind: "view_power_of_attorney", id: newActionId(), policy: marked })}
          disabled={!marked}
          variant="contained"
          size="large"
        >
          הוסף
        </Button>
      </DialogActions>
    </>
  );
};

export default ViewPowerOfAttorneyForm;
